(ns minorodata.components.connections.connector-filters
  (:require [clojure.string :as string]))

(defn filter-sources [all-sources tag]
  (if (= "all" tag)
    all-sources
    (filter #(some #{tag} (:tags %)) all-sources)))

(def filter-enabled
  (partial filter :enabled))

(defn filter-by-kind [connectors kind]
  (case kind
    "ingest"   (remove :is-exporter connectors)
    "exporter" (filter :is-exporter connectors)
    connectors))

(defn sort-sources [sources]
  ;; complement is needed here because otherwise nil and false are at the
  ;; beginning of the list when sorted by :enabled, and we need to reverse that
  (sort-by (juxt (complement :enabled)
                 (comp string/lower-case :name))
           sources))

(defn search-sources [sources search-term]
  (if (string/blank? search-term)
    sources
    (filter (fn name-search-filter [{:keys [name description]}]
              (let [lowercase-name (string/lower-case name)
                    lowercase-desc (string/lower-case description)
                    lowercase-term (string/lower-case search-term)]

                (or (string/includes? lowercase-name lowercase-term)
                    (string/includes? lowercase-desc lowercase-term))))
            sources)))

(def connector-tabs
  [{:value "all" :label "All"}
   {:value "data-import" :label "Data import"}
   {:value "analytics" :label "Analytics"}
   {:value "marketing" :label "Marketing"}
   {:value "admin-finance" :label "Admin and finance"}
   {:value "crm" :label "CRM"}
   {:value "erp" :label "ERP"}
   {:value "customer-support" :label "Customer Support"}
   {:value "inventory-management" :label "Inventory management"}])

(def kind-tabs
  [{:value "all" :label "All"}
   {:value "ingest" :label "Ingest"}
   {:value "exporter" :label "Exporter"}])
